import messages_en from './en.json';
import messages_fr from './fr.json';

export const language = 'fr';
export const messages = {
  en: messages_en,
  fr: messages_fr,
};
